import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';

export interface IGetConnectedApplicationResult extends IResult {
    connectedApplication: IConnectedApplicationType;
}

function getConnectedApplicationRequestConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'GET',
    endpoint: `connected-applications/${id}`,
    serverWideRequest: false
  };
}

export function callGetConnectedApplication(id: string): Promise<IGetConnectedApplicationResult> {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationResult>({
    config: getConnectedApplicationRequestConfig(id),
    request: null,
  });
}